import React, {useState, useEffect} from 'react';
import useSWR from 'swr';
import {getTranscriptions} from './utils'


export interface MyComponentProps {
  tresourceid: string// Define your prop types here
  handleChangeInfo: (id: string) => void;
  apikey?: string;
}

export const Chat: React.FC<MyComponentProps> = (props) => {
  
  const apikey = props.apikey ? props.apikey : (import.meta.env.VITE_API_KEY || "");
  const shortEid = props.tresourceid.split("/resource/")[1].split("/")[0];

  type FetchedTextType = { [key: string]: {id:string, authorTitle:string, longTitle:string, text:string} };
  const { data: fetchedText, error: textFetchError, isLoading: textIsLoading } = useSWR<FetchedTextType>(
    props.tresourceid ? `getTranscriptions:${shortEid}` : null, // SWR key
    () => getTranscriptions(shortEid) // Fetcher function with props.tresourceid as the argument
  );

  const [messages, setMessages] = useState<{ role: string; content: string }[]>([]);
  const [input, setInput] = useState<string>('');
  const [currentResponse, setCurrentResponse] = useState<string>('');

  useEffect(() => {
    setMessages([]);
    setInput('');
    setCurrentResponse('');
    if (fetchedText){
      // Send default passage when the component mounts
      let defaultPassage = `You are an instructor of medieval scholastic philosophy. 
      Your job is to explain the following text and its importance to an English-speaking student. 
      Can you summarize and explain the following text in approximately 300 words? 
      If the main text seems to oppose or argue with any related text please explain the argument. \n\n`;
  
      // Add the main text
      defaultPassage += `### Below is Main Text with its specific ID and text. Please use this ID when referring to the main text with the following pattern ID: <id> Important! Always use this EXACT ID###\n\n`;

      defaultPassage += `{
        "id": "sctar:${shortEid}",
        "author": "${fetchedText[props.tresourceid]?.authorTitle}",
      "citation": "${fetchedText[props.tresourceid].longTitle}",
        "text": "${fetchedText[props.tresourceid].text}"
      }\n\n`;

      // Add the main text
      defaultPassage += `### Below are Related Paragraphs with their specific IDs and text. Please use these IDs when referring to any related text with the following pattern ID: <id> Important! Always use this EXACT ID\n\n`;
      
       
     // Add related paragraphs
     Object.keys(fetchedText).forEach((key) => {
      if (key.split("/resource/")[1].split("/")[0] !== shortEid) {
        const id = `sctar:${key.split("/resource/")[1].split("/")[0]}`;
        defaultPassage += `{
          "id": "${id}",
          "author": "${fetchedText[key]?.authorTitle}",
          "citation": "${fetchedText[key].longTitle}",
          "text": "${fetchedText[key].text}"
        }\n\n`;
      }
     });

  // Send the constructed prompt
      sendMessage(defaultPassage);
    }
  }, [JSON.stringify(fetchedText), props.tresourceid]);

  // useEffect(() => {  
  //   // setMessages([]);
  //   // setInput('');
  //   // setCurrentResponse('');
  // },[props.tresourceid])

  

  const sendMessage = async (messageContent: string) => {
    const newMessage = { role: 'user', content: messageContent };
    const updatedMessages = [...messages, newMessage];
    setMessages(updatedMessages);
    setInput('');
    setCurrentResponse('');

    try {
      //const response = await fetch('http://localhost:11434/api/chat', {
      const response = await fetch('https://api.groq.com/openai/v1/chat/completions', {
        
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${apikey}`, // Replace with your actual API key
        },
        body: JSON.stringify({
          //model: 'llama3.2',
          //model: 'gpt-4',
          model: 'llama-3.3-70b-versatile',
          messages: updatedMessages,
          stream: true
        }),
      });

      if (!response.body) {
        throw new Error('ReadableStream not supported');
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder('utf-8');

      let done = false;
      let responseContent = '';
      let buffer = ''; // Buffer to store incomplete JSON chunks

      while (!done) {
        const { value, done: readerDone } = await reader.read();
        done = readerDone;
        if (value) {
          const chunk = decoder.decode(value, { stream: true });
          buffer += chunk; // Append the chunk to the buffer

          // Split the buffer into lines and process each line
          const lines = buffer.split('\n').filter(Boolean);
          buffer = ''; // Clear the buffer for the next iteration
          
       
        for (const line of lines) {
          if (line.startsWith('data:')) {
            const jsonString = line.replace(/^data: /, '').trim();
            if (jsonString === '[DONE]') {
              done = true; // End the loop if the stream is complete
              break;
            }
    
            try {
              const parsedLine = JSON.parse(jsonString); // Parse the JSON
              if (parsedLine.choices && parsedLine.choices[0].delta?.content) {
                const deltaContent = parsedLine.choices[0].delta.content;
                responseContent += deltaContent;
                setCurrentResponse((prev) => prev + deltaContent);
              }
            } catch (error) {
              // If JSON.parse fails, keep the remaining buffer for the next chunk
              buffer += jsonString + '\n';
            }
          }
        }


        }
      }

      const assistantMessage = {
        role: 'assistant',
        content: responseContent,
      };
      setMessages((prevMessages) => [...prevMessages, assistantMessage]);
      setCurrentResponse('');
    } catch (error) {
      console.error('Error sending message:', error);
    }
  };

  const handleSendMessage = () => {
    if (input.trim() === '') return;
    sendMessage(input);
  };

  return (
    <>
    {apikey ?
    <div>
      <div className="chat-window">
        {messages.slice(1).map((message, index) => (
          <div key={index} className={`message ${message.role}`}>
            <strong>{message.role}:</strong> 
            {message.content.split(' ').map((word, i) => {
            // Check if the word is a related text ID
            if (word.includes('sctar:')) {
              let id = word.split("sctar:")[1]
              id = id.replace(/^[^\w]*|[^\w]*$/g, '').trim();
              let longID = "http://scta.info/resource/" + id;
              return (
                <span className="lbp-span-link" onClick={() => {props.handleChangeInfo(longID)}} key={i} title={longID}> {id} </span>
              );
            }
            return <span key={i}>{word} </span>;
          })}
          </div>
        ))}
        {currentResponse && (
          <div className="message assistant">
            <strong>assistant:</strong> {currentResponse}
          </div>
        )}
      </div>
      <input
        type="text"
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyPress={(e) => e.key === 'Enter' && handleSendMessage()}
      />
      <button onClick={handleSendMessage}>Send</button>
    </div>
    :
    <div>
      <p>No API Key</p>
    </div>
    }
    </>
  );
};